/* ============================================================
   ประวัติ / การพูดคุยของ RC — ลูกค้า (ซ้าย) · เจ้าหน้าที่ (ขวา)
============================================================ */
import React from "react";
import { Empty, Timeline, Typography } from "antd";
import dayjs from "dayjs";
import { RcStatusTag } from "./rc";

export default function RcTimeline({ logs = [], viewer = "staff" }) {
  if (!logs.length) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="ยังไม่มีประวัติ" />;
  return (
    <Timeline
      className="ak-rc-timeline"
      items={logs.map((l) => {
        const mine = l.by_type === (viewer === "staff" ? "staff" : "customer");
        const who = l.by_type === "staff" ? (viewer === "customer" ? `เจ้าหน้าที่ AK HOME · ${l.by_name || ""}` : l.by_name || "เจ้าหน้าที่") : l.by_name || "ลูกค้า";
        return {
          color: l.by_type === "staff" ? "#9b6420" : "gray",
          children: (
            <div className={`ak-rc-log ${mine ? "is-mine" : ""} ${l.by_type}`}>
              <div className="ak-rc-log-head">
                <Typography.Text strong>{who}</Typography.Text>
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  {dayjs(l.created_date).format("DD/MM/YYYY HH:mm")}
                </Typography.Text>
              </div>
              {l.status && (
                <div style={{ margin: "2px 0" }}>
                  สถานะ <RcStatusTag value={l.status} />
                </div>
              )}
              {l.note && <div className="ak-rc-log-note">{l.note}</div>}
            </div>
          ),
        };
      })}
    />
  );
}
